// src/contexts/SocketContext.js - Optimized with focused contexts
import React from 'react';
import { BaseSocketProvider } from './BaseSocketContext';
import { MessageSocketProvider } from './MessageSocketContext';
import { NotificationSocketProvider } from './NotificationSocketContext';

// Re-export hooks for backward compatibility
export { useBaseSocket as useSocket } from './BaseSocketContext';
export { useMessageSocket } from './MessageSocketContext';
export { useNotificationSocket } from './NotificationSocketContext';

// Combined Socket Provider that uses focused contexts
export const SocketProvider = ({ children }) => {
    return (
        <BaseSocketProvider>
            <MessageSocketProvider>
                <NotificationSocketProvider>
                    {children}
                </NotificationSocketProvider>
            </MessageSocketProvider>
        </BaseSocketProvider>
    );
};

